export interface AddressCorrectionAddress {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string | null;
  city: string;
  zip: string;
  provinceCode: string;
  countryCode: string;
  phone: string;
}

export interface AddressCorrectionHistoryItem {
  orderId: number;
  orderName: string | null;
  orderNumber: number | null;
  status: 'corrected' | 'kept_original' | 'pending' | 'expired';
  originalAddress: AddressCorrectionAddress | null;
  correctedAddress: AddressCorrectionAddress | null;
}

export interface PageInfo {
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface AddressCorrectionHistoryResponse {
  items: AddressCorrectionHistoryItem[];
  pageInfo: PageInfo;
}

export interface AddressCorrectionHistoryQuery {
  cursor?: string;
  first?: number;
  last?: number;
  startDate?: string;
  endDate?: string;
  orderNumber?: number;
  status?: string;
}

export interface AddressCorrectionCountResponse {
  count: number;
}

export enum AddressCorrectionStatusTab {
  ALL = 'all',
  CORRECTED = 'corrected',
  PENDING = 'pending',
  KEPT_ORIGINAL = 'kept_original',
  EXPIRED = 'expired',
}

export const ADDRESS_CORRECTION_STATUS_MAP: Record<
  AddressCorrectionHistoryItem['status'],
  { label: string; variant: string }
> = {
  corrected: { label: 'Corrected', variant: 'success' },
  kept_original: { label: 'Kept original', variant: 'tertiary' },
  pending: { label: 'Pending', variant: 'secondary' },
  expired: { label: 'Expired', variant: 'danger' },
};
